import { useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errText } from "@/lib/api";

export const UNASSIGNED = "unassigned";

export const EnquiryAssignSelect = ({ enquiry, team, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  const value = enquiry.assigned_to || UNASSIGNED;

  const change = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/enquiries/${enquiry.enquiry_id}/assign`, {
        user_id: next === UNASSIGNED ? "" : next,
      });
      toast.success(data.assigned_to_name ? `Assigned to ${data.assigned_to_name}` : "Assignee removed");
      onUpdated?.(data);
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Select value={value} onValueChange={change} disabled={busy}>
      <SelectTrigger
        className="h-9 w-[160px] rounded-lg text-xs font-semibold"
        data-testid={`enquiry-assign-select-${enquiry.enquiry_id}`}
      >
        <SelectValue placeholder="Unassigned" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={UNASSIGNED} data-testid="assignee-option-unassigned">
          Unassigned
        </SelectItem>
        {team.map((m) => (
          <SelectItem key={m.user_id} value={m.user_id} data-testid={`assignee-option-${m.user_id}`}>
            {m.name || m.email}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default EnquiryAssignSelect;
